import { render } from "./find.vue?vue&type=template&id=39e87cc6"
import script from "./find.vue?vue&type=script&lang=js"
export * from "./find.vue?vue&type=script&lang=js"

import "./find.vue?vue&type=style&index=0&id=39e87cc6&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__